/* Bridgewater Direct: EasyCab cabinet configurator UI.
   Desktop: illustrated type cards and size cards (driving the existing selects), and an order list
   that holds several cabinets and adds them as separate basket lines in one go.
   Phone (<=767px): five-step journey. Every price, drawing and basket line comes from
   root.cabApi (the section's own engine): no second pricing path. */
(function () {
  'use strict';

  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function money(p) { return (Math.round(Number(p) || 0) / 100).toLocaleString('en-GB', { style: 'currency', currency: 'GBP' }); }
  function plural(n, a, b) { return n + ' ' + (n === 1 ? a : (b || a + 's')); }

  /* Simple, recognisable outline per catalogue type (illustrations only, not to scale). */
  var ICONS = {
    'Base Cabinet': '<rect x="10" y="8" width="44" height="34" rx="2"/><line x1="32" y1="8" x2="32" y2="42"/><line x1="14" y1="42" x2="14" y2="48"/><line x1="50" y1="42" x2="50" y2="48"/>',
    'Oven Base Cabinet': '<rect x="10" y="8" width="44" height="34" rx="2"/><rect x="16" y="14" width="32" height="20" rx="2"/><line x1="14" y1="42" x2="14" y2="48"/><line x1="50" y1="42" x2="50" y2="48"/>',
    'L-Shaped Corner Base': '<path d="M8 10 H56 V30 H30 V46 H8 Z"/><line x1="30" y1="30" x2="8" y2="30" stroke-dasharray="3 3"/>',
    'Drawer Base Cabinet': '<rect x="10" y="8" width="44" height="34" rx="2"/><line x1="10" y1="19" x2="54" y2="19"/><line x1="10" y1="30" x2="54" y2="30"/><line x1="28" y1="13" x2="36" y2="13"/><line x1="28" y1="24" x2="36" y2="24"/><line x1="28" y1="36" x2="36" y2="36"/><line x1="14" y1="42" x2="14" y2="48"/><line x1="50" y1="42" x2="50" y2="48"/>',
    'Wall Cabinet': '<line x1="6" y1="6" x2="58" y2="6"/><rect x="12" y="10" width="40" height="28" rx="2"/><line x1="32" y1="10" x2="32" y2="38"/>'
  };
  function icon(type) {
    return '<svg class="cab2-icon" viewBox="0 0 64 52" aria-hidden="true"><g fill="none" stroke="currentColor" stroke-width="2.2" stroke-linejoin="round" stroke-linecap="round">' + (ICONS[type] || ICONS['Base Cabinet']) + '</g></svg>';
  }
  var TYPE_NOTE = {
    'Base Cabinet': 'Floor units on 150mm adjustable feet',
    'Oven Base Cabinet': 'Housing for a built-under oven',
    'L-Shaped Corner Base': '900 × 900mm corner base',
    'Drawer Base Cabinet': 'Floor units with drawer faces',
    'Wall Cabinet': 'Wall-hung, 300mm deep'
  };

  function mount(root) {
    var api = root.cabApi;
    if (!api || root.dataset.cab2) return;
    root.dataset.cab2 = '1';
    var section = root.closest('.bw-cab') || root;
    var cfgJson = {};
    try { cfgJson = JSON.parse(root.querySelector('[data-cab2-config]').textContent || '{}'); } catch (e) {}
    var mq = window.matchMedia('(max-width: 767px)');
    var types = [];
    api.data.forEach(function (c) { if (types.indexOf(c.type) < 0) types.push(c.type); });
    var order = [];          // saved configurations, in order
    var priced = [];         // api.line() result per saved configuration
    var STORE = 'bd-cab2-order';
    try { var keep = JSON.parse(sessionStorage.getItem(STORE) || '[]'); if (Array.isArray(keep)) order = keep.filter(function (c) { return api.data.some(function (d) { return d.key === c.key; }); }); } catch (e) {}

    // Charged carcass-only price per size (the band price the basket uses, not the unrounded figure).
    var fromPrice = {};
    Promise.all(api.data.map(function (c) { return api.line({ key: c.key, door: 'none', colour: 'bd-graphite', hinge: 'left', handle: 'none', lock: 'none', drawerCount: 0, plinthQty: 0, shadowQty: 0, decorQty: 0, qty: 1 }).then(function (r) { if (r.ok) fromPrice[c.key] = r.bandPence; }); })).then(function () { renderDeskPickers(); if (mq.matches) renderApp(); });
    function carcassTxt(c) { return fromPrice[c.key] ? 'Carcass ' + money(fromPrice[c.key]) : 'Carcass price…'; }
    function save() { try { sessionStorage.setItem(STORE, JSON.stringify(order)); } catch (e) {} }
    function cabOf(cfg) { return api.data.find(function (c) { return c.key === cfg.key; }) || null; }
    function describe(cfg) {
      var cab = cabOf(cfg);
      if (!cab) return [];
      var door = cfg.door === 'add' && api.facesAvailable(cab);
      var hw = api.hardware(cfg) || {};
      var col = (api.colours[cfg.colour] || {}).name || '';
      var rows = [['Cabinet', cab.type + ' ' + api.sizeLabel(cab)], ['Carcass', 'White 18mm MFC']];
      if (api.isDrawer(cab)) {
        rows.push(['Drawers', door ? plural(cfg.drawerCount, 'drawer') + ' (' + api.formatRunners(api.drawerFit(cab, cfg.drawerCount) || []) + '), ' + col + ' faces' : 'Carcass only, no drawer faces']);
      } else if (!cab.davail) {
        rows.push(['Door', 'Carcass only (no door for this unit)']);
      } else {
        rows.push(['Door', door ? col + (hw.doors > 1 ? ' × ' + hw.doors : '') + (api.needsHingeChoice(cab) ? ', ' + (cfg.hinge === 'right' ? 'right' : 'left') + ' hinged' : (hw.doors > 1 ? ', pair' : '')) : 'Carcass only']);
        if (door) rows.push(['Hinges', hw.hinges + ' × Blum (2 per door)']);
      }
      if (door) {
        rows.push(['Handles', cfg.handle === 'add' ? hw.handles + ' × ' + api.specs.handle : 'None']);
        rows.push(['Locks', cfg.lock === 'add' ? hw.locks + ' × ' + api.specs.lock : 'None']);
      }
      var extras = [];
      if (cfg.plinthQty) extras.push(cfg.plinthQty + ' plinth');
      if (cfg.shadowQty) extras.push(cfg.shadowQty + ' infill');
      if (cfg.decorQty) extras.push(cfg.decorQty + ' decor panel');
      if (extras.length) rows.push(['Panels per cabinet', extras.join(', ') + ' (' + col + ')']);
      rows.push(['Quantity', String(cfg.qty)]);
      return rows;
    }
    function totals() {
      var t = 0, n = 0, bad = false;
      priced.forEach(function (p, i) { if (p && p.ok) { t += p.totalPence; n += order[i].qty; } else bad = true; });
      return { total: t, units: n, bad: bad };
    }
    function repriceAll() {
      return Promise.all(order.map(function (c) { return api.line(c); })).then(function (r) { priced = r; });
    }

    /* =========================== DESKTOP =========================== */
    var typeSel = root.querySelector('[id^="bwCabType-"]'), sizeSel = root.querySelector('[id^="bwCabSize-"]');
    var deskTypes = document.createElement('div'), deskSizes = document.createElement('div');
    deskTypes.className = 'cab2-types'; deskSizes.className = 'cab2-sizes';
    if (typeSel && sizeSel) {
      var typeField = typeSel.closest('.bw-field, label, div');
      var host = typeField && typeField.parentElement ? typeField.parentElement : typeSel.parentElement;
      host.insertAdjacentElement('beforebegin', deskTypes);
      host.insertAdjacentElement('beforebegin', deskSizes);
      host.classList.add('cab2-hidden-selects');
    }
    function renderDeskPickers() {
      if (!typeSel) return;
      deskTypes.innerHTML = '<p class="cab2-lbl">Cabinet type</p><div class="cab2-tgrid" role="radiogroup" aria-label="Cabinet type">' + types.map(function (t) {
        var on = typeSel.value === t;
        return '<button type="button" role="radio" aria-checked="' + on + '" class="cab2-tcard' + (on ? ' is-on' : '') + '" data-type="' + esc(t) + '">' + icon(t) + '<span>' + esc(t) + '</span><small>' + esc(TYPE_NOTE[t] || '') + '</small></button>';
      }).join('') + '</div>';
      var list = api.data.filter(function (c) { return c.type === typeSel.value; });
      deskSizes.innerHTML = '<p class="cab2-lbl">Size <small>Width × Depth × Height (mm), carcass</small></p><div class="cab2-sgrid" role="radiogroup" aria-label="Cabinet size">' + list.map(function (c) {
        var on = sizeSel.value === c.key;
        return '<button type="button" role="radio" aria-checked="' + on + '" class="cab2-scard' + (on ? ' is-on' : '') + '" data-key="' + esc(c.key) + '" data-bw-priced="dim"><strong>' + esc(api.sizeLabel(c).replace('mm', '')) + '</strong><small>' + carcassTxt(c) + '</small></button>';
      }).join('') + '</div>' + dimsNote(list[0]);
    }
    function dimsNote(cab) {
      if (!cab) return '';
      var wall = cab.type.indexOf('Wall') >= 0;
      return '<p class="cab2-dimnote">' + (wall ? 'Height is the carcass. Wall units have no feet.' : 'Height is the carcass only; base units stand on ' + api.specs.foot + 'mm adjustable feet (no plinth unless you add plinth rips).') +
        ' Depth is the carcass; a fitted door or drawer face adds ' + api.specs.doorThick + 'mm.</p>';
    }
    deskTypes.addEventListener('click', function (e) {
      var b = e.target.closest('[data-type]'); if (!b) return;
      typeSel.value = b.getAttribute('data-type'); typeSel.dispatchEvent(new Event('change')); renderDeskPickers();
    });
    deskSizes.addEventListener('click', function (e) {
      var b = e.target.closest('[data-key]'); if (!b) return;
      sizeSel.value = b.getAttribute('data-key'); sizeSel.dispatchEvent(new Event('change')); renderDeskPickers();
    });
    if (typeSel) { typeSel.addEventListener('change', renderDeskPickers); sizeSel.addEventListener('change', renderDeskPickers); }
    renderDeskPickers();

    // Order list: "Add cabinet to my order" beside the existing single add button.
    var addBtn = api.addButton, editing = -1;
    var addOrder = document.createElement('button');
    addOrder.type = 'button';
    addOrder.className = 'cab2-addorder';
    addOrder.textContent = 'Add cabinet to my order';
    if (addBtn) {
      addBtn.insertAdjacentElement('beforebegin', addOrder);
      addBtn.classList.add('cab2-single');
    }
    var panel = document.createElement('section');
    panel.className = 'cab2-order';
    panel.setAttribute('aria-label', 'Your cabinet order');
    var wizard = root.querySelector('.bw-wizard');
    if (wizard) wizard.insertAdjacentElement('afterend', panel);
    function syncAddOrder() {
      var off = !!(addBtn && addBtn.disabled);
      addOrder.disabled = off;
      addOrder.textContent = editing >= 0 ? 'Save changes to cabinet ' + (editing + 1) : 'Add cabinet to my order';
    }
    if (addBtn) new MutationObserver(syncAddOrder).observe(addBtn, { attributes: true, attributeFilter: ['disabled'] });
    addOrder.addEventListener('click', function () {
      var cfg = api.snapshot();
      if (!cfg.key) return;
      api.line(cfg).then(function (r) {
        if (!r.ok) { addOrder.textContent = r.reason; setTimeout(syncAddOrder, 2200); return; }
        if (editing >= 0) { order[editing] = cfg; editing = -1; } else order.push(cfg);
        save();
        return repriceAll().then(function () { renderAll(); panel.scrollIntoView({ behavior: 'smooth', block: 'start' }); });
      });
    });
    function cardsHtml(compact) {
      return order.map(function (c, i) {
        var p = priced[i] || {}, cab = cabOf(c);
        return '<article class="cab2-card"><div class="cab2-card__fig">' + (cab ? icon(cab.type) : '') + '</div><div class="cab2-card__b">' +
          '<p class="cab2-card__t">' + (i + 1) + '. ' + esc(cab ? cab.type : '') + ' <span>' + esc(cab ? api.sizeLabel(cab) : '') + '</span></p>' +
          '<ul>' + describe(c).slice(2).map(function (r) { return '<li><b>' + esc(r[0]) + ':</b> ' + esc(r[1]) + '</li>'; }).join('') + '</ul>' +
          '<p class="cab2-card__p">' + (p.ok ? money(p.totalPence) + ' <small>exc VAT' + (c.qty > 1 ? ' · ' + money(p.bandPence) + ' each' : '') + '</small>' : '<span class="cab2-err">' + esc(p.reason || 'Pricing…') + '</span>') + '</p></div>' +
          '<div class="cab2-card__a"><button type="button" data-ord="edit" data-i="' + i + '">Edit</button><button type="button" data-ord="dup" data-i="' + i + '">Duplicate</button><button type="button" data-ord="del" data-i="' + i + '">Remove</button></div></article>';
      }).join('');
    }
    function totalsHtml() {
      var t = totals();
      return '<dl class="cab2-totals"><div><dt>Cabinets</dt><dd>' + t.units + ' (' + plural(order.length, 'line') + ')</dd></div>' +
        '<div><dt>Delivery</dt><dd>' + esc(cfgJson.lead || 'Free UK') + '</dd></div>' +
        '<div class="cab2-totals__big"><dt>Total exc VAT</dt><dd>' + (t.total ? money(t.total) : '—') + '</dd></div>' +
        '<div><dt>VAT (20%)</dt><dd>' + (t.total ? money(t.total * 0.2) : '—') + '</dd></div>' +
        '<div><dt>Total inc VAT</dt><dd>' + (t.total ? money(t.total * 1.2) : '—') + '</dd></div></dl>';
    }
    function quoteHtml() {
      return '<div class="cab2-quote"><p class="cab2-quote__t">Need a full cabinet schedule?</p><p>Send us your cabinet list or drawings and we’ll prepare a quotation for your project.</p>' +
        '<a class="cab2-btn cab2-btn--ghost" href="mailto:' + esc(cfgJson.email) + '?subject=EasyCab%20cabinet%20schedule%20quotation">Request a quotation</a></div>';
    }
    function renderPanel() {
      if (!order.length) { panel.innerHTML = '<h2 class="cab2-h">Your order</h2><p class="cab2-sub">Configure a cabinet above and choose <strong>Add cabinet to my order</strong>. Add as many different cabinets as you need, then add them all to your basket together.</p>' + quoteHtml(); return; }
      var t = totals();
      panel.innerHTML = '<h2 class="cab2-h">Your order</h2><div class="cab2-cards">' + cardsHtml() + '</div>' + totalsHtml() +
        (t.bad ? '<p class="cab2-err">One or more cabinets can’t be priced online. Edit or remove it before ordering.</p>' : '') +
        '<button type="button" class="cab2-btn cab2-btn--primary cab2-btn--lg" data-ord="basket"' + (t.bad || busy ? ' disabled' : '') + '>' + (busy ? 'Adding to basket…' : 'Add ' + plural(t.units, 'cabinet') + ' to basket') + '</button>' +
        '<p class="cab2-status" role="status">' + esc(status) + '</p>' + quoteHtml();
    }
    var busy = false, status = '';
    function addAll() {
      if (busy || !order.length) return;
      busy = true; status = ''; renderAll();
      repriceAll().then(function () {
        if (priced.some(function (p) { return !p || !p.ok; })) throw new Error('A cabinet could not be priced.');
        return api.addLines(priced.map(function (p) { return p.item; }));
      }).then(function () {
        order = []; priced = []; save();
        window.location.href = '/cart';
      }).catch(function (err) {
        busy = false; status = (err && err.message ? err.message : 'Could not add to basket.').slice(0, 200); renderAll();
      });
    }
    function onOrder(a, i) {
      if (a === 'basket') { addAll(); return; }
      if (a === 'del') { order.splice(i, 1); priced.splice(i, 1); if (editing === i) editing = -1; save(); renderAll(); return; }
      if (a === 'dup') { order.splice(i + 1, 0, JSON.parse(JSON.stringify(order[i]))); priced.splice(i + 1, 0, priced[i]); save(); renderAll(); return; }
      if (a === 'edit') {
        if (mq.matches) { M.cfg = JSON.parse(JSON.stringify(order[i])); M.edit = i; go(4); return; }
        editing = i; api.applyToUI(order[i]); api.goStep('cabinet'); renderDeskPickers(); syncAddOrder();
        var w = root.querySelector('.bw-wizard'); if (w) w.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }
    }
    panel.addEventListener('click', function (e) { var b = e.target.closest('[data-ord]'); if (b && !b.disabled) onOrder(b.getAttribute('data-ord'), Number(b.getAttribute('data-i'))); });

    /* =========================== PHONE =========================== */
    var app = document.createElement('div');
    app.className = 'cab2-app';
    app.hidden = true;
    var hero = root.querySelector('.bw-prodgrid');
    (hero || root.firstElementChild).insertAdjacentElement('afterend', app);
    var bar = document.createElement('div');
    bar.className = 'cab2-bar';
    section.appendChild(bar);
    var M = { step: 1, cfg: freshCfg(), edit: -1, view: 'drawing', price: null, seq: 0 };
    function freshCfg(type) {
      var first = type ? api.data.find(function (c) { return c.type === type; }) : null;
      return { key: first ? '' : '', type: type || '', door: 'none', colour: 'bd-graphite', hinge: 'left', handle: 'none', lock: 'none', drawerCount: 0, plinthQty: 0, shadowQty: 0, decorQty: 0, qty: 1 };
    }
    function mcab() { return cabOf(M.cfg); }
    function reprice() {
      var seq = ++M.seq;
      if (!M.cfg.key) { M.price = null; renderBar(); return; }
      api.line(M.cfg).then(function (r) { if (seq !== M.seq) return; M.price = r; renderBar(); var el = app.querySelector('[data-m-price]'); if (el) el.innerHTML = priceTxt(); });
    }
    function priceTxt() {
      var r = M.price;
      if (!r) return 'Pricing…';
      if (!r.ok) return '<span class="cab2-err">' + esc(r.reason) + '</span>';
      return money(r.totalPence) + ' <small>exc VAT' + (M.cfg.qty > 1 ? ' · ' + money(r.bandPence) + ' each' : '') + '</small>';
    }
    function prog() {
      var names = ['Cabinet', 'Size', 'Options', 'Review', 'Order'];
      return '<ol class="cab2-prog">' + names.map(function (n, i) {
        var k = i + 1;
        return '<li class="' + (k === M.step ? 'is-on' : k < M.step ? 'is-done' : '') + '"><button type="button" data-m="step" data-n="' + k + '"' + (k === M.step ? ' aria-current="step"' : '') + '><span>' + k + '</span>' + n + '</button></li>';
      }).join('') + '</ol>';
    }
    function opt(name, val, label, on, sub) {
      return '<button type="button" class="cab2-opt' + (on ? ' is-on' : '') + '" role="radio" aria-checked="' + on + '" data-m="set" data-f="' + name + '" data-v="' + esc(val) + '"><span>' + label + '</span>' + (sub ? '<small>' + sub + '</small>' : '') + '</button>';
    }
    function stepper(name, val, label, sub, max) {
      return '<div class="cab2-stepper"><p><strong>' + label + '</strong>' + (sub ? '<small>' + sub + '</small>' : '') + '</p><div><button type="button" data-m="inc" data-f="' + name + '" data-d="-1" aria-label="Fewer"' + (val <= (name === 'qty' ? 1 : 0) ? ' disabled' : '') + '>−</button><output>' + val + '</output><button type="button" data-m="inc" data-f="' + name + '" data-d="1" aria-label="More"' + (val >= max ? ' disabled' : '') + '>+</button></div></div>';
    }
    function vType() {
      return '<h2 class="cab2-h">Choose your cabinet</h2><p class="cab2-sub">White 18mm MFC carcasses, flat-packed. Only the cabinets we stock are shown.</p><div class="cab2-tgrid cab2-tgrid--m">' + types.map(function (t) {
        var on = M.cfg.type === t, n = api.data.filter(function (c) { return c.type === t; }).length;
        return '<button type="button" class="cab2-tcard' + (on ? ' is-on' : '') + '" data-m="type" data-v="' + esc(t) + '">' + icon(t) + '<span>' + esc(t) + '</span><small>' + esc(TYPE_NOTE[t] || '') + ' · ' + plural(n, 'size') + '</small></button>';
      }).join('') + '</div>';
    }
    function vSize() {
      var list = api.data.filter(function (c) { return c.type === M.cfg.type; }), cab = mcab();
      return '<h2 class="cab2-h">Choose a size</h2><p class="cab2-sub">Width × Depth × Height (mm), carcass.</p><div class="cab2-sgrid">' + list.map(function (c) {
        var on = M.cfg.key === c.key, d = api.dims(c);
        return '<button type="button" class="cab2-scard' + (on ? ' is-on' : '') + '" data-m="size" data-v="' + esc(c.key) + '" data-bw-priced="dim"><strong>' + d.W + ' wide</strong><small>' + d.W + ' × ' + d.D + ' × ' + d.H + '</small><small>' + carcassTxt(c) + '</small></button>';
      }).join('') + '</div>' + (cab ? dimsNote(cab) + '<div class="cab2-fig">' + api.svg(M.cfg) + '</div>' : '');
    }
    function vOptions() {
      var cab = mcab();
      if (!cab) return '<p class="cab2-err">Choose a size first.</p>';
      var c = M.cfg, h = '<h2 class="cab2-h">Options</h2>';
      var faces = api.facesAvailable(cab), drawer = api.isDrawer(cab);
      if (!faces) h += '<p class="cab2-note">This unit is supplied as a carcass only (no door option in our catalogue).</p>';
      else {
        h += '<p class="cab2-q">' + (drawer ? 'Drawer faces' : 'Door') + '</p><div class="cab2-opts">' + opt('door', 'none', 'Carcass only', c.door !== 'add') + opt('door', 'add', drawer ? 'Add drawers + faces' : 'Add ' + ((cab.dqty || 1) > 1 && cab.type.indexOf('Corner') < 0 ? 'doors (pair)' : 'door'), c.door === 'add') + '</div>';
        if (c.door === 'add') {
          if (drawer) {
            var dro = api.drawerOptions(cab), btns = '';
            dro.options.forEach(function (o) { btns += opt('drawerCount', o.n, plural(o.n, 'drawer'), c.drawerCount === o.n, api.formatRunners(o.runners)); });
            h += '<p class="cab2-q">Drawer arrangement</p><div class="cab2-opts cab2-opts--col">' + btns + '</div>';
          } else if (api.needsHingeChoice(cab)) {
            h += '<p class="cab2-q">Hinge side</p><div class="cab2-opts">' + opt('hinge', 'left', '◧ Left hinged', c.hinge !== 'right', 'hinges on the left, handle on the right') + opt('hinge', 'right', '◨ Right hinged', c.hinge === 'right', 'hinges on the right, handle on the left') + '</div>';
          } else if ((cab.dqty || 1) > 1) h += '<p class="cab2-note">Supplied as a pair of doors.</p>';
          h += '<p class="cab2-q">Hardware <small>£' + (api.prices.handle / 100) + ' per handle, £' + (api.prices.lock / 100) + ' per lock, exc VAT</small></p><div class="cab2-opts">' + opt('handle', c.handle === 'add' ? 'none' : 'add', (c.handle === 'add' ? '✓ ' : '') + 'Handles', c.handle === 'add', '100mm D handle') + opt('lock', c.lock === 'add' ? 'none' : 'add', (c.lock === 'add' ? '✓ ' : '') + 'Locks', c.lock === 'add', 'one per door / drawer') + '</div>';
        }
      }
      var showColour = (c.door === 'add' && faces) || c.plinthQty || c.shadowQty || c.decorQty;
      h += '<p class="cab2-q">Plinths, infills and decorative panels <small>per cabinet</small></p>' +
        stepper('plinthQty', c.plinthQty, 'Plinth rips', api.specs.plinth + ' · £' + (api.prices.plinth / 100) + ' each', api.specs.accMax) +
        stepper('shadowQty', c.shadowQty, 'Infill panels', api.specs.shadow + ' · £' + (api.prices.shadow / 100) + ' each', api.specs.accMax) +
        stepper('decorQty', c.decorQty, 'Decorative panels', api.specs.decor + ' · £' + (api.prices.decor / 100) + ' each', api.specs.accMax);
      if (showColour) {
        h += '<p class="cab2-q">' + (c.door === 'add' && faces ? 'Door colour' : 'Panel colour') + '</p><div class="cab2-cols">' + Object.keys(api.colours).map(function (k) {
          var m = api.colours[k];
          return '<button type="button" class="cab2-col' + (c.colour === k ? ' is-on' : '') + '" data-m="set" data-f="colour" data-v="' + k + '" aria-pressed="' + (c.colour === k) + '"><i style="background:' + m.hex + '"></i>' + esc(m.name) + '</button>';
        }).join('') + '</div>';
        if (c.plinthQty || c.shadowQty || c.decorQty) h += '<p class="cab2-note">Plinths, infills and decorative panels are supplied in <strong>' + esc((api.colours[c.colour] || {}).name) + '</strong>, the same colour as ' + (c.door === 'add' && faces ? 'your doors' : 'chosen here') + '.</p>';
      }
      h += stepper('qty', c.qty, 'Quantity', 'of this cabinet; panels above are per cabinet', api.specs.qtyMax);
      return h;
    }
    function vReview() {
      var cab = mcab();
      if (!cab) return '<p class="cab2-err">Choose a cabinet first.</p>';
      return '<h2 class="cab2-h">Review cabinet</h2><div class="cab2-fig">' + api.svg(M.cfg) + '</div><button type="button" class="cab2-link" data-m="fs">View drawing full screen</button>' +
        '<dl class="cab2-spec">' + describe(M.cfg).map(function (r) { return '<div><dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd></div>'; }).join('') + '</dl>' +
        '<p class="cab2-price">Price: <strong data-m-price>' + priceTxt() + '</strong></p>' +
        '<p class="cab2-note">Drawing is to the catalogue sizes; hinge and fixing positions are not shown.</p>';
    }
    function vOrder() {
      var h = '<h2 class="cab2-h">Your order</h2>';
      h += order.length ? '<div class="cab2-cards">' + cardsHtml() + '</div>' : '<p class="cab2-sub">No cabinets yet.</p>';
      h += '<button type="button" class="cab2-btn cab2-btn--ghost cab2-btn--block" data-m="another">+ Add another cabinet</button>';
      if (order.length) h += totalsHtml() + (totals().bad ? '<p class="cab2-err">One or more cabinets can’t be priced online.</p>' : '') + '<p class="cab2-status" role="status">' + esc(status) + '</p>';
      return h + quoteHtml();
    }
    function renderApp() {
      if (!mq.matches) return;
      var v = M.step === 1 ? vType() : M.step === 2 ? vSize() : M.step === 3 ? vOptions() : M.step === 4 ? vReview() : vOrder();
      app.innerHTML = prog() + '<div class="cab2-view">' + v + '</div>';
      renderBar();
    }
    function renderBar() {
      if (!mq.matches) return;
      var left = '', btn = '', act = '', dis = false, r = M.price;
      var pr = r && r.ok ? money(r.totalPence) + ' <small>exc VAT</small><span class="cab2-bar__k">this cabinet</span>' : '<span class="cab2-bar__k">' + (r && !r.ok ? esc(r.reason) : M.cfg.key ? 'Pricing…' : 'Choose a cabinet') + '</span>';
      if (M.step === 1) { left = M.cfg.type ? '<span class="cab2-bar__k">Cabinet</span>' + esc(M.cfg.type) : '<span class="cab2-bar__k">Choose a cabinet type</span>'; btn = 'Next: size'; act = 'next'; dis = !M.cfg.type; }
      else if (M.step === 2) { left = pr; btn = 'Next: options'; act = 'next'; dis = !M.cfg.key; }
      else if (M.step === 3) { left = pr; btn = 'Review cabinet'; act = 'next'; dis = !(r && r.ok); }
      else if (M.step === 4) { left = pr; btn = M.edit >= 0 ? 'Save cabinet' : 'Add cabinet to my order'; act = 'save'; dis = !(r && r.ok); }
      else { var t = totals(); left = t.total ? money(t.total) + ' <small>exc VAT</small><span class="cab2-bar__k">' + money(t.total * 1.2) + ' inc VAT</span>' : '<span class="cab2-bar__k">No cabinets yet</span>'; btn = busy ? 'Adding…' : 'Add to basket'; act = 'basket'; dis = !order.length || t.bad || busy; }
      bar.innerHTML = '<div class="cab2-bar__in"><p class="cab2-bar__l">' + left + '</p><button type="button" class="cab2-btn cab2-btn--primary" data-m="' + act + '"' + (dis ? ' disabled' : '') + '>' + btn + '</button></div>';
    }
    function go(n, noHist) {
      if (n >= 2 && !M.cfg.type) n = 1;
      if (n >= 3 && !M.cfg.key) n = 2;
      M.step = n;
      if (!noHist) { try { history.pushState({ cab2: n }, ''); } catch (e) {} }
      renderApp(); reprice();
      var b = 0;
      document.querySelectorAll('.shopify-section-group-header-group').forEach(function (el) { var p = getComputedStyle(el).position, rr = el.getBoundingClientRect(); if ((p === 'sticky' || p === 'fixed') && rr.top <= 1 && rr.bottom > b) b = rr.bottom; });
      window.scrollTo({ top: Math.max(0, app.getBoundingClientRect().top + window.pageYOffset - b - 8), behavior: 'auto' });
    }
    window.addEventListener('popstate', function (e) { if (mq.matches && e.state && e.state.cab2) go(e.state.cab2, true); });
    function onM(el) {
      var a = el.getAttribute('data-m'), f = el.getAttribute('data-f'), v = el.getAttribute('data-v');
      var cab;
      switch (a) {
        case 'step': go(Number(el.getAttribute('data-n'))); break;
        case 'type': if (M.cfg.type !== v) { var keepQ = M.cfg; M.cfg = freshCfg(v); M.cfg.colour = keepQ.colour; } go(2); break;
        case 'size': M.cfg.key = v; M.cfg.drawerCount = 0; cab = mcab(); if (cab && !api.facesAvailable(cab)) M.cfg.door = 'none'; renderApp(); reprice(); break;
        case 'set':
          M.cfg[f] = (f === 'drawerCount') ? Number(v) : v;
          cab = mcab();
          if (f === 'door' && v === 'add' && cab && api.isDrawer(cab) && !M.cfg.drawerCount) M.cfg.drawerCount = api.drawerOptions(cab).preferred;
          if (f === 'door' && v !== 'add') { M.cfg.handle = 'none'; M.cfg.lock = 'none'; }
          renderApp(); reprice(); break;
        case 'inc': {
          var max = f === 'qty' ? api.specs.qtyMax : api.specs.accMax, min = f === 'qty' ? 1 : 0;
          M.cfg[f] = Math.min(max, Math.max(min, (M.cfg[f] || 0) + Number(el.getAttribute('data-d'))));
          renderApp(); reprice(); break;
        }
        case 'next': go(M.step + 1); break;
        case 'save': api.line(M.cfg).then(function (r) {
          if (!r.ok) return;
          var copy = JSON.parse(JSON.stringify(M.cfg));
          if (M.edit >= 0) order[M.edit] = copy; else order.push(copy);
          M.edit = -1; save(); return repriceAll().then(function () { renderPanel(); go(5); });
        }); break;
        case 'another': M.cfg = freshCfg(); M.edit = -1; M.price = null; go(1); break;
        case 'fs': openFs(); break;
        case 'basket': addAll(); break;
      }
    }
    app.addEventListener('click', function (e) {
      var b = e.target.closest('[data-m]'); if (b && !b.disabled) { onM(b); return; }
      var o = e.target.closest('[data-ord]'); if (o && !o.disabled) onOrder(o.getAttribute('data-ord'), Number(o.getAttribute('data-i')));
    });
    bar.addEventListener('click', function (e) { var b = e.target.closest('[data-m]'); if (b && !b.disabled) onM(b); });

    var fsd = null;
    function openFs() {
      if (!fsd) {
        fsd = document.createElement('dialog');
        fsd.className = 'cab2-fs';
        fsd.innerHTML = '<div class="cab2-fs__bar"><strong>Cabinet drawing</strong><span><button type="button" data-z="1.3" aria-label="Zoom in">+</button><button type="button" data-z="0.77" aria-label="Zoom out">−</button><button type="button" data-close aria-label="Close">✕</button></span></div><div class="cab2-fs__stage"><div class="cab2-fs__inner"></div></div>';
        document.body.appendChild(fsd);
        var z = 1, inner = fsd.querySelector('.cab2-fs__inner');
        fsd.addEventListener('click', function (e) {
          var b = e.target.closest('button'); if (!b) return;
          if (b.hasAttribute('data-close')) { fsd.close(); return; }
          z = Math.min(5, Math.max(1, z * Number(b.getAttribute('data-z')))); inner.style.transform = 'scale(' + z + ')';
        });
        fsd.addEventListener('close', function () { z = 1; inner.style.transform = ''; });
      }
      fsd.querySelector('.cab2-fs__inner').innerHTML = api.svg(M.cfg);
      if (fsd.showModal) fsd.showModal(); else fsd.setAttribute('open', '');
    }

    function renderAll() { renderPanel(); if (mq.matches) renderApp(); }
    function applyMode() {
      var on = mq.matches;
      section.classList.toggle('bw-cab--c2', on);
      app.hidden = !on; bar.hidden = !on;
      if (on) { renderApp(); reprice(); }
    }
    if (mq.addEventListener) mq.addEventListener('change', applyMode); else if (mq.addListener) mq.addListener(applyMode);
    repriceAll().then(renderAll);
    applyMode();
    syncAddOrder();
    root.cab2 = { order: function () { return order; }, priced: function () { return priced; }, reprice: repriceAll, render: renderAll };
  }

  window.BDCabUI = { mount: mount };
  // The engine mounts us at its init; if this file loads later (defer), mount now.
  function late() { document.querySelectorAll('[data-bw-cab-root]').forEach(function (r) { if (r.cabApi) mount(r); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', late); else late();
})();
